// src/components/ToastProvider.js
import React, { createContext, useContext, useState, useCallback } from "react";

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
    const [toasts, setToasts] = useState([]); // queue

    const addToast = useCallback((toast = {}, ms = 3500) => {
        const id = String(Date.now()) + Math.random().toString(36).slice(2, 8);
        const t = { id, ...toast };
        setToasts((s) => [...s, t]);
        if (ms > 0) setTimeout(() => setToasts((s) => s.filter((x) => x.id !== id)), ms);
        return id;
    }, []);

    const removeToast = useCallback((id) => setToasts((s) => s.filter((x) => x.id !== id)), []);

    return (
        <ToastContext.Provider value={{ addToast, removeToast }}>
            {children}
            <div aria-live="polite" style={{ position: "fixed", right: 20, bottom: 20, zIndex: 99999 }}>
                {toasts.map((t) => (
                    <div
                        key={t.id}
                        style={{
                            position: "fixed",
                            left: "50%",
                            transform: "translateX(-50%)",
                            top: 20,
                            background: "rgba(17,24,39,0.95)",
                            color: "white",
                            padding: "10px 14px",
                            borderRadius: 8,
                            boxShadow: "0 6px 18px rgba(2,6,23,0.3)",
                            zIndex: 9999,
                            maxWidth: 640,
                            textAlign: "center",
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
                            <div style={{ fontSize: 13 }}>
                                <strong style={{ textTransform: "uppercase", marginRight: 8 }}>{t.type || "Info"}</strong>
                                <span style={{ fontWeight: 500 }}>{t.msg}</span>
                            </div>
                            <button onClick={() => removeToast(t.id)} style={{ background: "transparent", color: "#fff", border: 0, cursor: "pointer" }}>✕</button>
                        </div>
                    </div>
                ))}
            </div>
        </ToastContext.Provider>
    );
}

export function useToast() {
    const ctx = useContext(ToastContext);
    if (!ctx) throw new Error("useToast must be used inside ToastProvider");
    return ctx;
}
